module.exports = __webpack_public_path__ + "img/logo.06daf1f4.png";